export const GENERAL_INFO = "General";
// Patient-reported health data — what the patient enters in the start-a-visit
// flow, including their own medication list.
export const MEDICAL_HISTORY = "Health";
export const VISITS = "Visits";
// What the doctor ordered, grouped by visit. Distinct from the medications in
// Health Profile, which are self-reported.
export const ORDERS = "Orders";
// Every doctor note (PDF) issued to the patient, across all visits.
export const DOCTOR_NOTES = "Notes";
export const UPLOAD_FILE = "Uploads";
export const PAYMENTS = "Payments";

// Order here IS the nav order: clinical context first (profile → visits), then
// what came out of those visits (orders → notes), then admin (files, payments).
export const TABS = [
  GENERAL_INFO,
  MEDICAL_HISTORY,
  VISITS,
  ORDERS,
  DOCTOR_NOTES,
  UPLOAD_FILE,
  PAYMENTS,
];

// Must stay in step with TABS — these index into it.
export const tabIndexes = {
  GENERAL_INFO: 0,
  MEDICAL_HISTORY: 1,
  VISITS: 2,
  ORDERS: 3,
  DOCTOR_NOTES: 4,
  UPLOAD_FILE: 5,
  PAYMENTS: 6,
};
